<div class="modal fade" [class.show]="isShown">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">{{ title }}</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="modelService.alertResultSignal.emit(false);close();">
			<span aria-hidden="true"><i class="fa fa-times"></i></span>
		  </button>
            </div>
            <div class="modal-body">
                <p class="lineHeight" *ngIf="message !== ''">{{message}}</p>
                <p class="lineHeight" *ngFor="let m of messages">&nbsp;{{m}}</p>
            </div>
            <div class="modal-footer">
                <button *ngIf="type === 'modal'" type="button" class="btn btn-primary" (click)="modelService.alertResultSignal.emit(true);close();">{{ modelService.getString('alert_button_accept') }}</button>
                <button type="button" class="btn btn-secondary" data-dismiss="modal" (click)="modelService.alertResultSignal.emit(false);close();">{{ modelService.getString('alert_button_close') }}</button>
            </div>
        </div>
    </div>
    <div></div>
</div>
